// src/MenuOpenContext.js
// 传递「可连接节点菜单是否打开」的轻量 context。
// 菜单打开期间（加下游节点这一步未完成），全局抑制所有拾取圈——
// 不管鼠标在哪、哪怕移回触发区，圆圈都不出现。菜单关闭后恢复。
// 独立成一个 context：SmartHandle 直接消费，菜单开关时只重渲染 handle，不动整个节点。

import React, { createContext, useContext } from 'react';

const MenuOpenContext = createContext(false);

export function MenuOpenProvider({ children, open }) {
  return (
    <MenuOpenContext.Provider value={open}>
      {children}
    </MenuOpenContext.Provider>
  );
}

export function useMenuOpen() {
  return useContext(MenuOpenContext);
}

export default MenuOpenContext;
